export const getStatesByCountry = (countryCode) => {
    const code = countryCode.toLowerCase();
    return states[code];
};
export const hasMatchingState = (countryCode, stateCode) => {
    const countryStates = getStatesByCountry(countryCode);
    if (!countryStates)
        return false;
    return stateCode.toLowerCase() in countryStates;
};
export const states = {
    us: {
        al: { name: 'Alabama', code: 'al' },
        ak: { name: 'Alaska', code: 'ak' },
        az: { name: 'Arizona', code: 'az' },
        ar: { name: 'Arkansas', code: 'ar' },
        ca: { name: 'California', code: 'ca' },
        co: { name: 'Colorado', code: 'co' },
        ct: { name: 'Connecticut', code: 'ct' },
        de: { name: 'Delaware', code: 'de' },
        dc: { name: 'District of Columbia', code: 'dc' },
        fl: { name: 'Florida', code: 'fl' },
        ga: { name: 'Georgia', code: 'ga' },
        hi: { name: 'Hawaii', code: 'hi' },
        id: { name: 'Idaho', code: 'id' },
        il: { name: 'Illinois', code: 'il' },
        in: { name: 'Indiana', code: 'in' },
        ia: { name: 'Iowa', code: 'ia' },
        ks: { name: 'Kansas', code: 'ks' },
        ky: { name: 'Kentucky', code: 'ky' },
        la: { name: 'Louisiana', code: 'la' },
        me: { name: 'Maine', code: 'me' },
        md: { name: 'Maryland', code: 'md' },
        ma: { name: 'Massachusetts', code: 'ma' },
        mi: { name: 'Michigan', code: 'mi' },
        mn: { name: 'Minnesota', code: 'mn' },
        ms: { name: 'Mississippi', code: 'ms' },
        mo: { name: 'Missouri', code: 'mo' },
        mt: { name: 'Montana', code: 'mt' },
        ne: { name: 'Nebraska', code: 'ne' },
        nv: { name: 'Nevada', code: 'nv' },
        nh: { name: 'New Hampshire', code: 'nh' },
        nj: { name: 'New Jersey', code: 'nj' },
        nm: { name: 'New Mexico', code: 'nm' },
        ny: { name: 'New York', code: 'ny' },
        nc: { name: 'North Carolina', code: 'nc' },
        nd: { name: 'North Dakota', code: 'nd' },
        oh: { name: 'Ohio', code: 'oh' },
        ok: { name: 'Oklahoma', code: 'ok' },
        or: { name: 'Oregon', code: 'or' },
        pa: { name: 'Pennsylvania', code: 'pa' },
        ri: { name: 'Rhode Island', code: 'ri' },
        sc: { name: 'South Carolina', code: 'sc' },
        sd: { name: 'South Dakota', code: 'sd' },
        tn: { name: 'Tennessee', code: 'tn' },
        tx: { name: 'Texas', code: 'tx' },
        ut: { name: 'Utah', code: 'ut' },
        vt: { name: 'Vermont', code: 'vt' },
        va: { name: 'Virginia', code: 'va' },
        wa: { name: 'Washington', code: 'wa' },
        wv: { name: 'West Virginia', code: 'wv' },
        wi: { name: 'Wisconsin', code: 'wi' },
        wy: { name: 'Wyoming', code: 'wy' },
    },
    au: {
        act: { name: 'Australian Capital Territory', code: 'act' },
        nsw: { name: 'New South Wales', code: 'nsw' },
        nt: { name: 'Northern Territory', code: 'nt' },
        qld: { name: 'Queensland', code: 'qld' },
        sa: { name: 'South Australia', code: 'sa' },
        tas: { name: 'Tasmania', code: 'tas' },
        vic: { name: 'Victoria', code: 'vic' },
        wa: { name: 'Western Australia', code: 'wa' },
    },
    ca: {
        ab: { name: 'Alberta', code: 'ab' },
        bc: { name: 'British Columbia', code: 'bc' },
        mb: { name: 'Manitoba', code: 'mb' },
        nb: { name: 'New Brunswick', code: 'nb' },
        nl: { name: 'Newfoundland and Labrador', code: 'nl' },
        nt: { name: 'Northwest Territories', code: 'nt' },
        ns: { name: 'Nova Scotia', code: 'ns' },
        nu: { name: 'Nunavut', code: 'nu' },
        on: { name: 'Ontario', code: 'on' },
        pe: { name: 'Prince Edward Island', code: 'pe' },
        qc: { name: 'Quebec', code: 'qc' },
        sk: { name: 'Saskatchewan', code: 'sk' },
        yt: { name: 'Yukon', code: 'yt' },
    },
    mx: {
        ag: { name: 'Aguascalientes', code: 'ag' },
        bj: { name: 'Baja California', code: 'bj' },
        bs: { name: 'Baja California Sur', code: 'bs' },
        cp: { name: 'Campeche', code: 'cp' },
        ch: { name: 'Chiapas', code: 'ch' },
        ci: { name: 'Chihuahua', code: 'ci' },
        cu: { name: 'Coahuila', code: 'cu' },
        cl: { name: 'Colima', code: 'cl' },
        df: { name: 'Distrito Federal', code: 'df' },
        dg: { name: 'Durango', code: 'dg' },
        gj: { name: 'Guanajuato', code: 'gj' },
        gr: { name: 'Guerrero', code: 'gr' },
        hg: { name: 'Hidalgo', code: 'hg' },
        ja: { name: 'Jalisco', code: 'ja' },
        em: { name: 'Mexico', code: 'em' },
        mh: { name: 'Michoacan', code: 'mh' },
        mr: { name: 'Morelos', code: 'mr' },
        na: { name: 'Nayarit', code: 'na' },
        nl: { name: 'Nuevo Leon', code: 'nl' },
    },
    cn: {
        bj: { name: 'Běijīng Shì', code: 'bj' },
        tj: { name: 'Tiānjīn Shì', code: 'tj' },
        he: { name: 'Héběi Shěng', code: 'he' },
        sx: { name: 'Shānxī Shěng', code: 'sx' },
        nm: { name: 'Nèi Měnggǔ Zìzhìqū', code: 'nm' },
        ln: { name: 'Liáoníng Shěng', code: 'ln' },
        jl: { name: 'Jílín Shěng', code: 'jl' },
        hl: { name: 'Hēilóngjiāng Shěng', code: 'hl' },
        sh: { name: 'Shànghǎi Shì', code: 'sh' },
        js: { name: 'Jiāngsū Shěng', code: 'js' },
        zj: { name: 'Zhèjiāng Shěng', code: 'zj' },
        ah: { name: 'Ānhuī Shěng', code: 'ah' },
        fj: { name: 'Fújiàn Shěng', code: 'fj' },
        jx: { name: 'Jiāngxī Shěng', code: 'jx' },
        sd: { name: 'Shāndōng Shěng', code: 'sd' },
        ha: { name: 'Hénán Shěng', code: 'ha' },
        hb: { name: 'Húběi Shěng', code: 'hb' },
        hn: { name: 'Húnán Shěng', code: 'hn' },
        gd: { name: 'Guǎngdōng Shěng', code: 'gd' },
        gx: { name: 'Guǎngxī Zhuàngzú Zìzhìqū', code: 'gx' },
        hi: { name: 'Hǎinán Shěng', code: 'hi' },
        cq: { name: 'Chóngqìng Shì', code: 'cq' },
        sc: { name: 'Sìchuān Shěng', code: 'sc' },
        gz: { name: 'Guìzhōu Shěng', code: 'gz' },
        yn: { name: 'Yúnnán Shěng', code: 'yn' },
        xz: { name: 'Xīzàng Zìzhìqū', code: 'xz' },
        sn: { name: 'Shǎnxī Shěng', code: 'sn' },
        gs: { name: 'Gānsù Shěng', code: 'gs' },
        qh: { name: 'Qīnghǎi Shěng', code: 'qh' },
        nx: { name: 'Níngxià Huízú Zìzhìqū', code: 'nx' },
        xj: { name: "Xīnjiāng Wéiwú'ěr Zìzhìqū", code: 'xj' },
        hk: { name: 'Xiānggǎng Tèbié Xíngzhèngqū', code: 'hk' },
        mc: { name: 'Àomén Tèbié Xíngzhèngqū', code: 'mc' },
        tw: { name: 'Táiwān Shěng', code: 'tw' },
    },
    jp: {
        hokkaido: { name: 'hokkaido', code: '北海道' },
        aomori: { name: 'aomori', code: '青森県' },
        iwate: { name: 'iwate', code: '岩手県' },
        miyagi: { name: 'miyagi', code: '宮城県' },
        akita: { name: 'akita', code: '秋田県' },
        yamagata: { name: 'yamagata', code: '山形県' },
        fukushima: { name: 'fukushima', code: '福島県' },
        ibaraki: { name: 'ibaraki', code: '茨城県' },
        tochigi: { name: 'tochigi', code: '栃木県' },
        gunma: { name: 'gunma', code: '群馬県' },
        saitama: { name: 'saitama', code: '埼玉県' },
        chiba: { name: 'chiba', code: '千葉県' },
        tokyo: { name: 'tokyo', code: '東京都' },
        kanagawa: { name: 'kanagawa', code: '神奈川県' },
        niigata: { name: 'niigata', code: '新潟県' },
        toyama: { name: 'toyama', code: '富山県' },
        ishikawa: { name: 'ishikawa', code: '石川県' },
        fukui: { name: 'fukui', code: '福井県' },
        yamanashi: { name: 'yamanashi', code: '山梨県' },
        nagano: { name: 'nagano', code: '長野県' },
        gifu: { name: 'gifu', code: '岐阜県' },
        shizuoka: { name: 'shizuoka', code: '静岡県' },
        aichi: { name: 'aichi', code: '愛知県' },
        mie: { name: 'mie', code: '三重県' },
        shiga: { name: 'shiga', code: '滋賀県' },
        kyoto: { name: 'kyoto', code: '京都府' },
        osaka: { name: 'osaka', code: '大阪府' },
        hyogo: { name: 'hyogo', code: '兵庫県' },
        nara: { name: 'nara', code: '奈良県' },
        wakayama: { name: 'wakayama', code: '和歌山県' },
        tottori: { name: 'tottori', code: '鳥取県' },
        shimane: { name: 'shimane', code: '島根県' },
        okayama: { name: 'okayama', code: '岡山県' },
        hiroshima: { name: 'hiroshima', code: '広島県' },
        yamaguchi: { name: 'yamaguchi', code: '山口県' },
        tokushima: { name: 'tokushima', code: '徳島県' },
        kagawa: { name: 'kagawa', code: '香川県' },
        ehime: { name: 'ehime', code: '愛媛県' },
        kochi: { name: 'kochi', code: '高知県' },
        fukuoka: { name: 'fukuoka', code: '福岡県' },
        saga: { name: 'saga', code: '佐賀県' },
        nagasaki: { name: 'nagasaki', code: '長崎県' },
        kumamoto: { name: 'kumamoto', code: '熊本県' },
        oita: { name: 'oita', code: '大分県' },
        miyazaki: { name: 'miyazaki', code: '宮崎県' },
        kagoshima: { name: 'kagoshima', code: '鹿児島県' },
        okinawa: { name: 'okinawa', code: '沖縄県' },
    },
};
//# sourceMappingURL=states.js.map